/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IWorkValuesSorter {
        assessmentName: string;
        assessmentId: number;
        currentSession: IAssessmentSession;
        assessment: IAssessment;
        questions: IQuestion[];
        sessions: IAssessmentSession[];
        assessmentResults: IWorkValueSorterResult[];
        inProgress: boolean;
        state: State;
        loading: boolean;
        answers: IAnswer[];
        selections: any[][];
        rankedResults: IWorkValueSorterResult[];
        rankingChart: any;
    }

    interface ICareerClusterResult {
        careerCluster: ICareerCluster;
        count: number;
    }

    interface ICareerCluster {
        id: number;
        title: string;
        description: string;
        code: number;
    }

    class State {
        step: number;
        sessionId?: number;
    }


    class WorkValuesSorter implements IWorkValuesSorter {
        static controllerId: string = "workValuesSorter";
        static $inject: string[] = ["$scope", "common", "Restangular", "$q", "$location", "$routeParams", "config"];

        assessmentName: string = "work-values-Sorter";
        assessmentId = 5;
        currentSession: IAssessmentSession;
        assessment: IAssessment;
        questions: IQuestion[];
        sessions: IAssessmentSession[];
        assessmentResults: IWorkValueSorterResult[];
        progressGauge: any;
        inProgress: boolean;
        categories: any;
        state: State = new State();
        loading: boolean = true;
        answers: IAnswer[];
        selections: any[][];
        rankedResults: IWorkValueSorterResult[];
        rankingChart: any;
        ncCareersUrl: string;
        cacheBuster = Date.now() + '' + Math.random().toString(36).substring(10);

        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        constructor(private $scope: ng.IScope, private common: ICommonFactory, private Restangular: Restangular.IService, private $q: ng.IQService,
            private $location: ng.ILocationService, private $routeParams: angular.route.IRouteParamsService, private config: IConfig) {

            this.log = common.logger.getLogFn(WorkValuesSorter.controllerId);
            this.logError = common.logger.getLogFn(WorkValuesSorter.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(WorkValuesSorter.controllerId, "success");
            this.ncCareersUrl = config.ncCareersUrl;

            this.common.authentication.authenticate(true).then(() => {
                this.activate();

                if (this.$location.state()) {
                    this.state = this.$location.state();
                } else {
                    this.saveState(1, null).replace();
                }

                this.questions = [];
                this.initializeSelections();
                this.rankingChart = this.barChartOptions;

                this.$scope.$on("$routeUpdate", () => {
                    if (this.$location.state()) {
                        this.state = this.$location.state();
                    }
                });

                this.activate();
            });
        }

        initializeSelections() {
            this.selections = [];
            for (var i = 0; i < 4; i++) {
                this.selections.push([null, null, null, null, null]);
            }
        }

        activate() {
            var promises: ng.IPromise<any>[] = [this.getAssessment(), this.getCategories()];

            this.common.activateController(promises, WorkValuesSorter.controllerId)
                .then(() => {
                    if (this.state.step && this.state.sessionId && this.state.step == 3) {
                        this.getResults(this.state.sessionId);
                    }
                    else if (this.state.step && this.state.step == 2) {
                        this.startOrResumeSession();
                    }

                    if (this.sessions == null) {
                        this.getSessions();
                    }

                    this.loading = false;
                });
        }

        saveState(step?: number, sessionId?: number) {
            return this.$location.state({
                step: step ? step : this.state.step ? this.state.step : 1,
                sessionId: sessionId ? sessionId : this.currentSession ? this.currentSession.id : null
            });
        }

        deleteSession(): ng.IPromise<void> {
            var defer = this.$q.defer<void>();

            var inProgressSession = _.find(this.sessions, (s) => s.isComplete == false);

            if (inProgressSession) {
                this.Restangular.one("assessments", this.assessmentId).one("sessions", inProgressSession.id).remove()
                    .then(() => defer.resolve(),
                        (reason) => {
                            this.logError(reason.message, reason, true);
                        });
            }
            else {
                defer.resolve();
            }

            return defer.promise;
        }

        getAssessment(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).get<IAssessment>()
                .then((result) => {
                    this.assessment = result;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getSessions(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).one("sessions").get<IAssessmentSession[]>()
                .then((sessions: IAssessmentSession[]) => {
                    this.sessions = sessions;
                    this.inProgress = _.some(this.sessions, (s) => s.isComplete == false);
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getCurrentSession(): ng.IPromise<IAssessmentSession> {
            return this.Restangular.one("assessments", this.assessmentId).one("session").get<IAssessmentSession>();
        }

        getQuestions(): ng.IPromise<void> {
            var questions: ng.IPromise<any>;
            return this.Restangular.one("assessments", this.assessmentId).one("questions").get<IRestResult<IQuestion[]>>({ pageSize: 20 })
                .then((result: IRestResult<IQuestion[]>) => {
                    this.questions = result.results;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        getResults(sessionId: number): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentName).one("sessions", sessionId).one("results").get()
                .then((results) => {
                    this.assessmentResults = results;
                    var topScores = _.take(_.map(_.uniqBy(this.assessmentResults, 'score'), 'score'), 2);

                    this.rankedResults = _.filter(this.assessmentResults, (r) => r.score >= topScores[1]);
                    this.rankingChart.series[0].data = [];
                    this.rankingChart.xAxis.categories = [];
                    this.assessmentResults.forEach(r => {
                        this.rankingChart.xAxis.categories.push(r.category.name);
                        this.rankingChart.series[0].data.push(r.score);

                    });

                    this.saveState(3, sessionId);
                },
                    (reason) => {
                        this.logError(reason.message, reason, false);
                    });

        }

        getCategories(): ng.IPromise<any> {
            return this.Restangular.one("assessments", this.assessmentId).one("categories").get()
                .then((result) => {
                    this.categories = result;
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        complete(): ng.IPromise<void> {
            return this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id).one("complete").put()
                .then(() => {
                    this.getResults(this.currentSession.id);
                }, (reason) => {
                    this.logError(reason.message, reason, true);
                });
        }

        startOrResumeSession(): ng.IPromise<void> {
            var currentSession = this.getCurrentSession().then(result => {
                this.currentSession = result;
                if (this.currentSession.answers == null) {
                    this.currentSession.answers = [];
                }

            }, (reason) => {
                this.logError(reason.message, reason, true);
            });

            var questions = this.getQuestions();

            return this.$q.all<void, void>([currentSession, questions])
                .then(() => {
                    this.selectAnswers();
                    this.saveState(2, this.currentSession.id);
                });
        }

        selectAnswers() {
            var answers = this.currentSession.answers;
            var rowIdx = [0, 0, 0, 0, 0];

            answers.forEach(function (answer) {
                var colIdx = parseInt(answer.answer);
                var question = _.remove(this.questions, (q: IQuestion) => q.id == answer.questionId);
                this.selections[rowIdx[colIdx]][colIdx] = { question: question[0], answer: answer }
                rowIdx[colIdx] += 1;
            }, this)

        }

        startOver() {
            this.deleteSession()
                .then(() => {
                    this.currentSession = null;
                    this.initializeSelections();
                    this.startOrResumeSession();
                });
        }


        toggleAnswer(question: IQuestion) {
            var idx = _.findIndex<IAnswer>(this.currentSession.answers, { questionId: question.id } as IAnswer);
            if (idx == -1) {
                var answer: IAnswer = {
                    id: null,
                    sessionId: this.currentSession.id,
                    assessmentId: this.assessmentId,
                    questionId: question.id,
                    categoryId: question.categoryId,
                    interestAreaId: null,
                    answer: "1"
                };
                this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id)
                    .one("questions", question.id).all("answers").post(answer)
                    .then((result) => {
                        answer.id = result;
                        this.currentSession.answers.push(answer);
                    }, (reason) => {
                        this.logError(reason.message, reason, true);
                    });
            } else {
                var answer = this.currentSession.answers.splice(idx, 1)[0];
                this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id)
                    .one("questions", question.id).one("answers", answer.id).remove()
                    .then(null, (reason) => {
                        this.logError(reason.message, reason, true);
                    });
            }

            this.selectAnswers();
        }

        saving = false;

        select(row, column) {
            var question: IQuestion;

            if (this.saving) {
                return;
            }

            if (this.selections[row][column] == null) {
                this.saving = true;
                question = this.questions.shift();


                var answer: IAnswer = {
                    id: null,
                    answer: column,
                    assessmentId: this.assessmentId,
                    questionId: question.id,
                    categoryId: question.categoryId,
                    interestAreaId: null,
                    sessionId: this.currentSession.id
                }

                this.selections[row][column] = { question: question, answer: answer };

                this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id)
                    .one("questions", question.id).all("answers").post(answer)
                    .then((result) => {
                        answer.id = result;
                    }, (reason) => {
                        this.logError(reason.message, reason, true);
                    }).finally(() => { this.saving = false; });

            }
            else {
                this.saving = true;
                question = this.selections[row][column].question;
                this.Restangular.one("assessments", this.assessmentId).one("sessions", this.currentSession.id)
                    .one("questions", question.id).one("answers", this.selections[row][column].answer.id).remove()
                    .then(() => {
                        this.selections[row][column] = null;
                        this.questions.unshift(question);
                    }, (reason) => {
                        this.logError(reason.message, reason, true);
                    }).finally(() => { this.saving = false; });;
            }
        }

        skip() {
            this.questions.push(this.questions.shift());
        }

        get barChartOptions() {
            return {
                chart: {
                    type: 'bar',
                    height: 200
                },
                title: {
                    text: null
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    minTickInterval: 1
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    }
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    borderWidth: 0,
                    backgroundColor: 'none',
                    shadow: false,
                    pointFormat: "",
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [{
                    data: []
                }]
            };
        }
    }

    angular.module("app").controller(WorkValuesSorter.controllerId, WorkValuesSorter);
}